if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
      for (let item of MutationList) {
        if (
          item.target.classList.contains("predictive-search-drawer_results-container")
        ) {
          setTimeout(() => {
            BSS_B2B.observer.productSubject.notifyObserver(
            "ProductMutate",
            "ProductPriceMutate"
            );
          }, 1000);
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }, 300);
}

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    const isPDP = BSS_B2B.page.isProductPage()

    if (!isPDP) {
      return;
    }

    BSS_B2B.observer.productSubject.notifyObserver(
        "ProductMutate",
        "ProductPriceMutate"
    );
  }, 1000);
});

const netTermButton = document.getElementById('bss-b2b-net-term-button-wrapper');
const hasNetTermButton = Boolean(document.querySelector('#bss-b2b-net-term-button-wrapper button'));

const checkout = document.querySelector('.cart__footer .btn-wrapper.cart-checkout-button-wrapper')
const te = document.querySelector('.bss-b2b-discount-code-wrapper.bss-config-header')
const freeShipping = document.querySelector('.free-shipping-bar')

if (checkout  && (hasNetTermButton || Boolean(freeShipping))) {

    // move netTermButton after checkout
    checkout.insertAdjacentElement('afterend', netTermButton);

    // move te after freeShipping
    freeShipping.insertAdjacentElement('afterend', te);
}
